module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "comment-box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "comment-li"
    }, [_c('div', {
      staticClass: "comment-li-user flex-start"
    }, [_c('img', {
      attrs: {
        "src": item.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "comment-li-user-name"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "comment-li-title"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('div', {
      staticClass: "comment-li-pic flex-start"
    }, _vm._l((item.pics), function(pic, picIndex) {
      return _c('div', {
        key: picIndex,
        staticClass: "comment-li-pic-li"
      }, [_c('img', {
        attrs: {
          "src": pic.url,
          "alt": ""
        }
      })])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "comment-li-star"
    }, [_c('van-rate', {
      attrs: {
        "size": 25,
        "color": "#ffd21e",
        "void-icon": "star",
        "void-color": "#eee",
        "readonly": ""
      },
      model: {
        value: (item.star),
        callback: function($$v) {
          _vm.$set(item, "star", $$v)
        },
        expression: "item.star"
      }
    })], 1)])
  }), 0)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd95f528","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/goods/GoodsComment.vue
// module id = 2595
// module chunks = 0